module.exports = __webpack_public_path__ + "static/img/brees-2002-1.70f7dc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2002-1.jpg
// module id = 7bgg
// module chunks = 1